import { getCurrentUser } from '../helpers/UserUtility';
import { Template } from '../types/template-types';
import { RecoveryTemplate } from './templateeditor-types';

function getRecoveryKeyForTemplate(templateId: string) {
  return `template_${templateId}`;
}

export function saveTemplateForRecovery(template: Template) {
  const user = getCurrentUser();
  localStorage.setItem(getRecoveryKeyForTemplate(template.id), JSON.stringify({ template, timeStamp: new Date(), user: { name: user.fullName, id: user.id } }));
}

export function hasRecoveredTemplate(id: string) {
  return localStorage.getItem(getRecoveryKeyForTemplate(id)) !== null;
}

export function getRecoveredTemplate(id: string): RecoveryTemplate {
  const storageItem = localStorage.getItem(getRecoveryKeyForTemplate(id));
  return storageItem ? JSON.parse(storageItem) : null;
}

export function clearRecoveredTemplate(id: string) {
  localStorage.removeItem(getRecoveryKeyForTemplate(id));
}
